import { ChevronRight } from 'lucide-react';
import * as React from 'react';
interface StatCardProps {
  value: string | number;
  label: string;
  icon?: boolean;
  onClick?: () => void;
  className?: string;
}
export function StatCard({
  value,
  label,
  icon,
  onClick,
  className
}: StatCardProps) {
  return <div className={`flex h-full flex-col overflow-hidden rounded-lg border border-solid border-black/10 bg-white p-4  shadow-[0px_2px_8px_rgba(0,0,0,0.09)] ${className}`} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} onKeyDown={event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.();
    }
  }} data-sentry-component="StatCard" data-sentry-source-file="stat-card.tsx">
      <div className="text-2xl font-medium tracking-tight">{value}</div>
      <div className="mt-1 flex w-full items-center gap-1.5 text-xs">
        <div className="my-auto self-stretch">{label}</div>
        {icon && <button type="button" className="z-0 my-auto flex  items-center justify-center  gap-1.5 overflow-hidden rounded-[34px] bg-x-button-background p-1 text-center text-base font-medium text-x-accent-alpha">
            <ChevronRight className="size-3" />
          </button>}
      </div>
    </div>;
}
;